import { calculateBlobMD5 } from "@common/utils";
import axios from "axios";
import JSZip from "jszip";
import { UploadFile } from "antd";

interface FeedbackData {
  userId: string;
  userPhone: string;
  suggest: string;
  logUrl: string;
}

interface CstorePolicy {
  priority: number;
  type: string;
  uploadUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formFields: Array<{ key: string; value: any }>;
}

class FeedbackHandler {
  static uploadPolicy: string =
    "https://os-busniess-line.maxhub.com/open/users/new-airdisk/upload-policy";
  static apiFeedback: string = `${
    import.meta.env.VITE_BACKEND_URL
  }/api/open/feedback/4087367550f24017ad870a838165982e`;

  public static async commit(params: FeedbackData) {
    console.log("feedback commit params = ", params);
    const feedbackResponse = await axios
      .post(this.apiFeedback, {
        feedbackPerson: params.userId,
        feedbackPersonPhone: params.userPhone,
        title: "Maxhub会记问题反馈",
        appId: "com.maxhub.maxlink",
        appName: "AI会记反馈",
        channel: 8,
        type: "4d3bfb56bdd841a898e2cd4fd9fc3166",
        productId: "4087367550f24017ad870a838165982e",
        content: params.suggest,
        annex:
          params.logUrl &&
          JSON.stringify([{ name: "日志文件", url: params.logUrl }]),
      })
      .catch((error) => {
        console.log("feedback commit error", error);
        return Promise.resolve(false);
      });
    console.log("feedbackResponse = ", feedbackResponse);
    return Promise.resolve(true);
  }

  // 上传文件：md5->获取策略->上传到cstore
  private static async startUpload(file: Blob, fileName: string) {
    try {
      const md5 = await calculateBlobMD5(file);

      console.log(`开始获取上传协议 ${fileName} md5=${md5}`);
      const data = await this.getUploadPolicy(md5, file.size);

      const formData = new FormData();

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      data.formFields.forEach((field: any) => {
        formData.append(field.key, field.value);
      });
      formData.append("file", file, fileName);

      console.log(`开始上传文件 ${fileName} md5=${md5}`);
      const response = await axios.post(data.uploadUrl, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.log(`文件上传进度: ${progress}%`);
          }
        },
      });
      console.log("文件上传成功", response);
      return response.data.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (e.errCode === "ERR_CANCELED") {
        console.log("请求已取消");
        return;
      }
      console.log("上传失败", e);
    }
  }

  static async uploadLogHandle(fileList: UploadFile[]) {
    if (!fileList.length) {
      return null;
    }

    try {
      // 创建zip实例
      const zip = new JSZip();

      // 将所有图片添加到zip中
      const promises = fileList.map(async (file) => {
        // 获取原始文件
        const originalFile = file.originFileObj;
        if (!originalFile) return;

        // 生成文件名（使用原始文件名或生成新的）
        const fileName =
          originalFile.name ||
          `image_${Date.now()}.${originalFile.type.split("/")[1]}`;

        // 将文件添加到zip中
        zip.file(fileName, originalFile);
      });

      // 等待所有文件添加完成
      await Promise.all(promises);

      // 生成zip文件
      const zipBlob = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: {
          level: 9,
        },
      });

      // 上传zip文件
      const response = await this.startUpload(
        zipBlob,
        `feedback_${Date.now()}.zip`
      );

      console.log("startUpload", response);

      return {
        success: !!response?.downloadUrl,
        data: response?.downloadUrl || "",
      };
    } catch (error) {
      console.error("Upload failed:", error);
      return {
        success: false,
        error,
      };
    }
  }
  // 获取上传协议
  private static async getUploadPolicy(
    fileHash: string,
    fileSize: number
  ): Promise<CstorePolicy> {
    const policy = await axios.post(this.uploadPolicy, {
      fileHash: fileHash.substring(0, 28),
      fileSize: fileSize,
      orgId: 0,
      keySuffix: ".zip",
    });
    // console.log('协议内容', policy.data.data.policyResult.policyList[0]);
    const policyFisrt = policy.data.data.policyResult.policyList[0];
    return policyFisrt;
  }
}

export default FeedbackHandler;
